import { render, staticRenderFns } from "./GeneralSettingsTimezone.vue?vue&type=template&id=1bd0f2ac&"
import script from "./GeneralSettingsTimezone.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsTimezone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports